import { useEffect, useId, useState } from 'react';
import { Icon } from '../design/Icon';
import { Avatar } from './Avatar';
import { SPACES, useShell } from './ShellContext';

/**
 * Sélecteur d'espace (« Famille Durand ▾ »). Statique pour l'instant : seul l'espace PERSONAL existe côté
 * serveur, le choix reste local et ne change aucune donnée.
 */
export function SpaceSwitcher({ variant = 'sidebar' }: { variant?: 'sidebar' | 'mobile' }) {
  const { space, setSpace } = useShell();
  const [open, setOpen] = useState(false);
  const menuId = useId();

  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent): void => {
      if (e.key === 'Escape') setOpen(false);
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open]);

  return (
    <div className="sh-space" data-variant={variant}>
      <button
        type="button"
        className="sh-space__btn"
        aria-haspopup="menu"
        aria-expanded={open}
        aria-controls={open ? menuId : undefined}
        onClick={() => setOpen((v) => !v)}
      >
        <Avatar initial={space.label.charAt(0)} size={variant === 'sidebar' ? 28 : 32} tone="accent" />
        <span className="sh-space__name">{space.label}</span>
        <Icon name="down" size={16} />
      </button>
      {open ? (
        <>
          <div className="sh-scrim" onClick={() => setOpen(false)} aria-hidden="true" />
          <div className="sh-menu" id={menuId} role="menu" aria-label="Espaces">
            {SPACES.map((s) => (
              <button
                key={s.id}
                type="button"
                role="menuitemradio"
                aria-checked={s.id === space.id}
                className="sh-menu__item"
                onClick={() => {
                  setSpace(s);
                  setOpen(false);
                }}
              >
                <Avatar initial={s.label.charAt(0)} size={24} tone="accent" />
                <span style={{ flex: 1 }}>{s.label}</span>
                {s.id === space.id ? <Icon name="check" size={16} /> : null}
              </button>
            ))}
          </div>
        </>
      ) : null}
    </div>
  );
}
